module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "radio-button-container",
    class: _vm.button_disabled
  }, [_c('input', {
    ref: "radioCheckbox",
    staticClass: "radio-button-checkbox",
    class: _vm.group,
    attrs: {
      "type": "checkbox",
      "radio": ""
    },
    on: {
      "click": _vm.check
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "radio-button",
    class: [_vm.type, _vm.is_correct]
  }, [_c('div', {
    staticClass: "radio-button-indicator",
    class: [_vm.type, _vm.is_correct]
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cd2d79b4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/atoms/radio.vue
// module id = 667
// module chunks = 1